<template>
    <div class="container">
        <div
            v-if="!hasPerson || user.submitting"
            class="row mb"
            data-qa="person-loading"
        >
            <div class="col-12">
                <h2>{{ t('Profile.Security.Section2FA.Headline') }}</h2>

            </div>
            <div class="col-12 col-md-12 col-lg-8 text-align--center">
                <p>{{ t('General.IsLoading') }}</p>
                <CrefoRingLoading />
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-12">
                    <h2>{{ t('Profile.Security.Section2FA.Headline') }}</h2>
                </div>
                <div v-if="!hasOtpConfigured">
                    <div class="col-12 mb">
                        <p>{{
                            t('Profile.Security.Section2FA.Activate.Subline1')
                        }}</p>
                        <p>{{
                            t('Profile.Security.Section2FA.Activate.Subline2')
                        }}</p>
                    </div>
                    <div class="col-12">
                        <p>
                            <button
                                data-qa="configure-otp-button"
                                class="btn btn-default text-semibold link-icon-next"
                                @click="configureOTP(getLanguage())"
                            >
                                <span>{{
                                    t(
                                        'Profile.Security.Section2FA.Activate.ButtonText'
                                    )
                                }}</span>
                            </button>
                        </p>
                    </div>
                </div>
                <div v-else>
                    <div class="col-12 mb">
                        <h3>
                            <i
                                class="crefo-brand-icon icon-check-circle text-brand-blue"
                                style="margin-right: 5px"
                                aria-hidden="true"
                            />
                            {{
                                t(
                                    'Profile.Security.Section2FA.Deactivate.Subline1'
                                )
                            }}
                        </h3>
                        <p>{{
                            t('Profile.Security.Section2FA.Deactivate.Subline2')
                        }}</p>
                    </div>
                    <div class="col-12">
                        <p>
                            <button
                                data-qa="deactivate-otp-button"
                                class="btn btn-default bg-brand-red text-semibold link-icon-next"
                                @click="removeOTP(credentialId, getLanguage())"
                            >
                                <span>{{
                                    t(
                                        'Profile.Security.Section2FA.Deactivate.ButtonText'
                                    )
                                }}</span>
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { onMounted } from 'vue'
import CrefoRingLoading from '@/components/helper/ring-loading'
import getLanguage from '@/helper/language'
import { configureOTP, removeOTP } from '@/services/keycloak-service'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'

const store = useUserStore()
const { t } = useI18n()
const {
    getUser: user,
    hasPerson,
    is2FAActive: hasOtpConfigured,
    getCredentialId: credentialId
} = storeToRefs(store)

onMounted(() => {
    store.getPersonMeMFACredentials()
})
</script>

